import { useNavigate } from 'react-router-dom';
import { Button, Chip, Typography } from '@mui/material';
import DashboardLayout from '../components/DashboardLayout';
import DataTable from '../components/DataTable';
import { officerNav } from '../components/officerNav';
import usePaginatedList from '../hooks/usePaginatedList';

const STATUS_COLOR = {
  DRAFT: 'default', PUBLISHED: 'success', CLOSED: 'warning', CANCELLED: 'error',
};

const FILTERS = {
  historical: { isHistorical: 'true' },
  needsLocation: { isHistorical: 'true', missingLocation: 'true' },
  closed: { status: 'CLOSED' },
};

export default function ContractAwardList() {
  const navigate = useNavigate();
  const list = usePaginatedList('/tenders', { pageSize: 25, filters: FILTERS });

  const columns = [
    { key: 'reference', header: 'Reference' },
    { key: 'title', header: 'Project' },
    {
      key: 'location',
      header: 'Location',
      render: (t) => (t.location
        ? t.location
        : <Typography variant="body2" color="warning.main">Not recorded</Typography>),
    },
    {
      key: 'status',
      header: 'Status',
      render: (t) => <Chip size="small" label={t.status} color={STATUS_COLOR[t.status]} />,
    },
    {
      key: 'actions',
      header: '',
      align: 'right',
      render: (t) => (
        <Button size="small" onClick={() => navigate(`/officer/award/${t.id}`)}>
          Manage award
        </Button>
      ),
    },
  ];

  return (
    <DashboardLayout nav={officerNav} title="Contract Awards">
      <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
        Select a tender to record and publish its contract award.
      </Typography>

      <DataTable
        {...list}
        columns={columns}
        searchPlaceholder="Search by reference, project or school…"
        emptyMessage="No tenders yet."
        filterOptions={[
          { key: 'needsLocation', label: 'Needs location' },
          { key: 'historical', label: 'Historical records' },
          { key: 'closed', label: 'Closed' },
        ]}
      />
    </DashboardLayout>
  );
}